// extracted by mini-css-extract-plugin
module.exports = {"root":"_1k1AJ","tr":"_10RZu","br":"_1sJrn","bl":"XQoq_","tl":"_21J1Y"};